
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-V1/[[...pathname]]",
      function () {
        return require("private-next-pages/content-V1/[[...pathname]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-V1/[[...pathname]]"])
      });
    }
  